import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { WasteStationListPage } from 'pages/app/waste-station-list/WasteStationListPage'

const wasteStationListSearchSchema = z.object({
  includeDeleted: z.boolean().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/app/mottagsstation/')({
  validateSearch: wasteStationListSearchSchema,
  component: WasteStationListPage,
})
